/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { hasCookie, setCookie } from 'services/actions/cookies_actions';
import createTrack from 'services/actions/tracker_actions';
import { Container } from './styles';

const COOKIE_PREFIX = 'ConlicitasegOnlyPromoModal';
const PROMO_SOURCE = 'Modal Promocional ConlicitaSeg Only';
const VIDEO_URL = process.env.REACT_APP_CONLICITASEG_PROMO_VIDEO_URL || '';

export const promoModalCookie = (userId: number) => `${COOKIE_PREFIX}_${userId}`;

export const hasDismissedPromoModal = (userId: number) => hasCookie(promoModalCookie(userId));

interface ConlicitasegOnlyPromoModalProps {
  show?: boolean;
  onHide?: () => void;
  source?: string;
}

const ConlicitasegOnlyPromoModal: React.FC<ConlicitasegOnlyPromoModalProps> = ({
  show,
  onHide,
  source = PROMO_SOURCE,
}) => {
  const history = useHistory();
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const isControlled = show !== undefined;
  const [autoShow, setAutoShow] = useState<boolean>(
    () => !isControlled && !hasDismissedPromoModal(profile.id),
  );
  const isOpen = isControlled ? !!show : autoShow;

  // Aberta pelo banner (controlada), não marca como dispensada: o painel segue abrindo sozinho
  const dismiss = () => {
    if (isControlled) {
      onHide?.();
      return;
    }
    setCookie(promoModalCookie(profile.id), true);
    setAutoShow(false);
  };

  const handleClose = () => {
    createTrack('ConlicitaSeg Only - Fechou modal promocional', { fonte: source });
    dismiss();
  };

  const handleFreeTrial = () => {
    createTrack('ConlicitaSeg Only - Clicou em cortesia de 15 dias de teste', {
      fonte: source,
    });
    (window as any).Tawk_API?.maximize?.();
    dismiss();
  };

  const handleSeePlans = () => {
    createTrack('ConlicitaSeg Only - Clicou em ver planos e preços', { fonte: source });
    dismiss();
    history.push('/planos');
  };

  return (
    <Modal show={isOpen} onHide={handleClose} centered size="lg" backdrop="static">
      <Container>
        <button type="button" className="close-button" onClick={handleClose} aria-label="Fechar">
          <i className="material-icons">close</i>
          <span className="ml-2">Fechar</span>
        </button>

        {VIDEO_URL && (
          <iframe
            className="promo-video"
            src={VIDEO_URL}
            title="Conheça a plataforma ConLicitação"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        )}

        <p className="promo-title">
          Conlicitação - o mais completo banco de dados de avisos de licitações, editais e
          acompanhamentos de processos licitatórios do país.
        </p>

        <p className="promo-subtitle">
          Tenha acesso agora mesmo as principais licitações do país, com acompanhamento, gestão,
          documentos, ferramentas de IA, conteúdos jurídicos , análise de concorrentes, fornecedores
          e muito mais.
        </p>

        <div className="promo-actions">
          <button type="button" className="btn btn-primary" onClick={handleFreeTrial}>
            Quero cortesia de 15 dias de teste
          </button>
          <button type="button" className="btn btn-outline-primary" onClick={handleSeePlans}>
            Ver planos e preços
          </button>
        </div>
      </Container>
    </Modal>
  );
};

export default ConlicitasegOnlyPromoModal;
